import React, {Suspense} from "react";
import AppRouter from "router/AppRouter";
import {ErrorBoundary} from "providers/ErrorBoundary";

const App: React.FC = () => {
    return (
        <ErrorBoundary fallback={
            (<div style={{flex: 1, minHeight: 0, height: '100vh', width: '100vw'}}>
                <div className="loading-container" style={{height: '100%', direction: 'rtl'}}>
                    <div>
                        אירעה שגיאה, נא לרענן.
                    </div>
                </div>
            </div>)}>
            <Suspense fallback={(<div style={{flex: 1, minHeight: 0, height: '100vh', width: '100vw'}}>
                <div className="loading-container" style={{height: '100%', direction: 'rtl'}}>
                    <div className="loading-spinner"></div>
                </div>
            </div>)}>
                <AppRouter/>
            </Suspense>
        </ErrorBoundary>
    );
};
export default App;
